import React, { useState } from "react";

import LinkIcon from "@common/assets/images/link.svg";
import Tooltip from "@common/components/Tooltip/Tooltip";

import * as Styled from "./TicketKey.styles";

interface Props {
  ticketKey: string;
  enableCopy?: boolean;
  marginLeft?: number;
  marginRight?: number;
}

export function TicketKeyCopy({ ticketKey, enableCopy, marginLeft, marginRight }: Props) {
  const [copied, setCopied] = useState(false);

  const onCopyPress = () => {
    navigator.clipboard.writeText(window.location.href);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!ticketKey) return null;

  return (
    <Styled.TicketKeyRoot
      $enableCopy={enableCopy}
      $marginLeft={marginLeft}
      $marginRight={marginRight}
    >
      <Tooltip
        text={"Ticket ID"}
        position={"top"}
      >
        <TicketKeyPill ticketKey={ticketKey} />
      </Tooltip>

      {enableCopy ? (
        <Tooltip
          text={!copied ? "Copy link" : "Copied!"}
          position={"bottom"}
        >
          <Styled.TicketKeyLink
            className={"ticket-key-link"}
            onClick={onCopyPress}
          >
            <img
              src={LinkIcon}
              alt={"Link icon"}
            />
          </Styled.TicketKeyLink>
        </Tooltip>
      ) : null}
    </Styled.TicketKeyRoot>
  );
}

interface TicketKeyPillProps {
  ticketKey: string;
}

export function TicketKeyPill({ ticketKey }: TicketKeyPillProps) {
  return (
    <Styled.TicketKeyPill>
      <Styled.TicketKeyText>{ticketKey}</Styled.TicketKeyText>
    </Styled.TicketKeyPill>
  );
}
